module.exports = __webpack_public_path__ + "img/sdk-placed.ac523b5c.png";